import { useQuery } from '@tanstack/react-query';

import { venueGetSubscriptionUpgradeCostApi } from '../../../api/stripe/venueGetSubscriptionUpgradeCost';
import { VenueGetSubscriptionUpgradeCostInput } from '../../../graphql/API';

export const useVenueGetSubscriptionUpgradeCostQuery = (
  filters: VenueGetSubscriptionUpgradeCostInput,
) => {
  const { data, isFetching, isError, isLoading } = useQuery({
    queryKey: ['venueGetVerificationUrl', { ...filters }],
    queryFn: async ({ queryKey }) => {
      const [, filters] = queryKey as [string, VenueGetSubscriptionUpgradeCostInput];

      return venueGetSubscriptionUpgradeCostApi(filters);
    },
    refetchOnWindowFocus: false,
    enabled: !!filters.newPriceID && !!filters.subscriptionID,
  });
  return { data, isFetching, isError, isLoading };
};
